import { useParams } from "react-router-dom";
import { getDatabase, ref, get } from "firebase/database";
import { useEffect, useState, useCallback } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";
import { toast } from "../components/toast";
import { useNavigate } from "react-router-dom";




function NewsArticle() {
  const { newsSlug } = useParams();

  const [article, setArticle] = useState(null);
  const [articleOwner, setArticleOwner] = useState(null);
  const [loading, setLoading] = useState(true);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [carouselImages, setCarouselImages] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // console.log("NewsArticle component rendered with slug:", articleOwner);
  const navigate = useNavigate();

  // Memoize navigation functions
  const handlePrevSlide = useCallback(() => {
    setCarouselIndex((prevIndex) =>
      prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1
    );
  }, [carouselImages.length]);

  const handleNextSlide = useCallback(() => {
    setCarouselIndex((prevIndex) =>
      prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
    );
  }, [carouselImages.length]);

  // Handle ESC key to close fullscreen
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      }
      // Arrow key navigation in fullscreen
      if (isFullscreen && carouselImages.length > 0) {
        if (e.key === 'ArrowLeft') {
          handlePrevSlide();
        } else if (e.key === 'ArrowRight') {
          handleNextSlide();
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isFullscreen, carouselImages.length, handlePrevSlide, handleNextSlide]);

  // Prevent body scroll when fullscreen is open
  useEffect(() => {
    if (isFullscreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isFullscreen]);

  const formatArticleDate = (dateStr) => {
    if (!dateStr) return '';
    const [day, month, year] = dateStr.split('/');
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  };

  // Fetch the article based on slug
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const db = getDatabase();
        const snapshot = await get(ref(db, "NEWS/"));

        if (snapshot.exists()) {
          const newsData = snapshot.val();
          const foundEntry = Object.entries(newsData).find(
            ([_, newsArticle]) => newsArticle.NEWS_ARTICLESLUG === newsSlug
          );

          if (foundEntry) {
            const [, foundArticle] = foundEntry;
            setArticle(foundArticle);
          } else {
            // console.warn("Article not found with slug:", newsSlug);
          }
        }
      } catch (error) {
        // console.error("Error loading article:", error);
        toast("Error loading article", "#", "danger");
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [newsSlug]);

  // Load article owner details
  useEffect(() => {
    const ownerId = article?.NEWS_ARTICLEOWNER;
    if (!ownerId) {
      setArticleOwner(null);
      return;
    }

    const db = getDatabase();
    const ownerRef = ref(db, `USERS/${ownerId}`);

    get(ownerRef)
      .then((snap) => {
        if (snap.exists()) {
          setArticleOwner({
            id: ownerId,
            ...snap.val(),
          });
        } else {
          setArticleOwner(null);
        }

      })

      .catch((err) => {
        console.error("Failed to fetch article owner:", err);
        setArticleOwner(null);
      });
  }, [article]);

  // Load carousel images from public directory
  useEffect(() => {
    if (!article?.NEWS_ARTICLESLUG) {
      setCarouselImages([]);
      return;
    }
    
    if (article.NEWS_ARTICLEIMAGES === "Y") {
      const loadImages = async () => {
        const images = [];
        const cleanSlug = article.NEWS_ARTICLESLUG.replace(/\s+/g, '');
        const baseUrl = `/assets/img/NEWS/${cleanSlug}`;
        const imagesAmount = parseInt(article.NEWS_ARTICLEIMAGESAMOUNT) || 0;

        // console.log("Loading carousel images:", {
        //   slug: article.NEWS_ARTICLESLUG,
        //   cleanSlug,
        //   baseUrl,
        //   imagesAmount,
        //   newsImages: article.NEWS_ARTICLEIMAGES
        // });

        // Load up to the specified amount of images
        for (let i = 1; i <= imagesAmount; i++) {
          const imageUrl = `${baseUrl}/newsimage${i}.jpg`;
          
          // Create a promise that resolves when image loads or rejects on error
          try {
            const imageLoaded = await new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => {
                // console.log(`Image ${i} loaded: ${imageUrl}`);
                resolve(imageUrl);
              };
              img.onerror = () => {
                reject(new Error(`Failed to load ${imageUrl}`));
              };
              img.src = imageUrl;
            });
            images.push(imageLoaded);
          } catch (error) {
            // console.warn(`Image ${i} not found at ${imageUrl}`);
            // Continue trying other images instead of breaking
          }
        }
        
        // console.log(`Carousel loaded: ${images.length} images out of ${imagesAmount}`);
        
        if (images.length > 0) {
          setCarouselImages(images);
          setCarouselIndex(0);
        } else {
          // console.warn("No carousel images loaded. Check if images exist at:", baseUrl);
        }
      };

      loadImages().catch(err => console.error("Error loading carousel images:", err));
    } else {
      setCarouselImages([]);
    }
  }, [article]);


  useTitle(`- ${article ? article.NEWS_ARTICLETITLE : "Loading..."}`);
  


  if (loading)
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-default bg-opacity-80 z-50">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 border-4 text-primary border-t-transparent rounded-full animate-spin"></div>
          <h4 className="fw-bolder mb-3 mt-3">Loading...</h4>
        </div>
      </div>
    );

  if (!article) return <p className="text-center py-5">Article not found.</p>;


            if (article.NEWS_ARTICLEPUBLIC === "N") {
                navigate("/news", { replace: true });
                return;
            }


    const formattedDescription = (article.NEWS_ARTICLEFULLDESC || "").replace(/\n/g, "<br/>");
    const formattedDescription2 = (article.NEWS_ARTICLEFULLDESC2 || "").replace(/\n/g, "<br/>");

    const newsTags = (article.NEWS_ARTICLETAGS || "").split(' ');
// console.log("Parsed news tags:", newsTags);
    const newsEventLinks = (article.NEWS_EVENTSLUG || "").split(' ');
    //  console.log("Parsed news tags:", newsEventLinks);

    const goToSlide = (index) => {
      setCarouselIndex(index);
    };

  return (
    <div>
      <Navbar />
      
      <div className="App-header mt-5 mb-5">
        <div className="container-md">
          <h1 className="article-heading-start text-center">{article.NEWS_ARTICLETITLE}</h1>
          <p className="article-sub-text">
           <span className="small"> {formatArticleDate(article.NEWS_ARTICLEDATE)}</span> 
          </p>

        <div className="filter-section"></div>

        </div>
      </div>

      <div className="container-md mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">

            <div className="article-content mb-5">
                {article.NEWS_ARTICLESHORTDESC && (
                    <p className="article-heading-para  mb-4"> <b>{article.NEWS_ARTICLESHORTDESC }</b></p>
                )}

                <div className="article-body" dangerouslySetInnerHTML={{ __html: formattedDescription}}>
                </div>
            </div>


                    {carouselImages.length > 0 && (
                    <div className="news-carousel-holder mb-5">
                        <div className="news-carousel">
                        <div className="carousel-main" onClick={() => setIsFullscreen(true)}>
                            <img 
                            src={carouselImages[carouselIndex]} 
                            alt={`Article slide ${carouselIndex + 1}`}
                            className="carousel-image"
                            title="Click to view fullscreen"
                            />
                        </div>

                        {carouselImages.length > 1 && (
                            <>
                            <button 
                                className="carousel-btn carousel-btn-prev"
                                onClick={handlePrevSlide}
                                aria-label="Previous slide"
                            >
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <button 
                                className="carousel-btn carousel-btn-next"
                                onClick={handleNextSlide}
                                aria-label="Next slide"
                            >
                                <i className="bi bi-chevron-right"></i>
                            </button>

                            <div className="carousel-indicators">
                                {carouselImages.map((_, index) => (
                                <button
                                    key={index}
                                    className={`carousel-dot ${index === carouselIndex ? 'active' : ''}`}
                                    onClick={() => goToSlide(index)}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                                ))}
                            </div>
                            </>
                        )}
                        </div>
                    </div>
                    )}

                    {/* Fullscreen Modal */}
                    {isFullscreen && carouselImages.length > 0 && (
                        <div className="carousel-fullscreen-overlay" onClick={() => setIsFullscreen(false)}>
                            <button 
                                className="carousel-close-btn"
                                onClick={() => setIsFullscreen(false)}
                                aria-label="Close fullscreen"
                                title="Press ESC to close"
                            >
                                ×
                            </button>

                            <div className="carousel-image-counter">
                                {carouselIndex + 1} / {carouselImages.length}
                            </div>

                            <div className="carousel-fullscreen-container" onClick={(e) => e.stopPropagation()}>
                                <img 
                                    src={carouselImages[carouselIndex]} 
                                    alt={`Fullscreen slide ${carouselIndex + 1}`}
                                    className="carousel-fullscreen-image"
                                />

                                {carouselImages.length > 1 && (
                                    <>
                                    <button 
                                        className="carousel-fullscreen-nav carousel-fullscreen-nav-prev"
                                        onClick={handlePrevSlide}
                                        aria-label="Previous slide"
                                    >
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                    <button 
                                        className="carousel-fullscreen-nav carousel-fullscreen-nav-next"
                                        onClick={handleNextSlide}
                                        aria-label="Next slide"
                                    >
                                        <i className="bi bi-chevron-right"></i>
                                    </button>

                                    <div className="carousel-fullscreen-indicators">
                                        {carouselImages.map((_, index) => (
                                        <button
                                            key={index}
                                            className={`carousel-fullscreen-dot ${index === carouselIndex ? 'active' : ''}`}
                                            onClick={() => goToSlide(index)}
                                            aria-label={`Go to slide ${index + 1}`}
                                        />
                                        ))}
                                    </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}

            <div className="article-content mb-5">
                <div className="article-body" dangerouslySetInnerHTML={{ __html: formattedDescription2}}>
                </div>
            </div>

                {newsEventLinks.length > 0 && newsEventLinks[0] !== "" && (
                    <div className="mb-2">
                    <h5 className="event-sub-title">Related Events</h5>
                      <div className="row">
                        {newsEventLinks.map((link, index) => ( 
                            <div className="col-auto mb-2" key={index}>
                              <a key={index} className="article-rlevents-badges upper" href={`/event/${link}`} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-calendar3-week me-2"></i> {link.replace(/-/g, ' ')}
                              </a>
                            </div>
                        ))}
                      </div>
                    </div>
                )}

                <div className="filter-section"></div>

                {newsTags.length > 0 && newsTags[0] !== "" && (
                    <div className="mb-4"> 
                      <div className="d-flex flex-wrap gap-2">
                        {newsTags.map((tag, index) => ( 
                            <span key={index} className="article-tags-badges">
                                {tag}
                            </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <p className="event-sub-title eventownername"  data-bs-toggle="modal" data-bs-target="#eventOwnerModal"> {articleOwner && ` Written by ${articleOwner.USERDISPLAYNAME || "Unknown"}`}</p> 


          </div>
          
        </div>
      </div>

            <div className="modal fade" id="eventOwnerModal" tabIndex="-1" aria-labelledby="eventOwnerModalLabel" aria-hidden="true" data-backdrop="false">
              <div className="modal-dialog ">
                <div className="modal-content ">
                  
                  <div className="modal-body">
                    
                    <div className="user-bg"> </div>
                    <div className="aaaa">
                      <div className="imgg-user"><i className="bi bi-person-circle gggggg"></i></div>
                    </div>
                    
                    <h5 className="text-center"> {articleOwner && ` Written by ${articleOwner.USERDISPLAYNAME || "Unknown"}`}</h5>
                  
                    <p className="text-center mt-4">
                      {articleOwner &&  articleOwner.USERISADMIN === "Y" && (
                        <span className="event-badges ms-2">
                          <i className="bi bi-shield-check me-1 admin-badge"></i>
                            Admin
                        </span> 
                      )} 
                      {articleOwner &&  (articleOwner.USERISVERYFIED === "Y") && (
                          <span className="event-badges ms-2">
                            <i className="bi bi-check2-circle me-1 verified-badge"></i>
                            Verified
                          </span>
                      )}   
                    </p>
                  </div>
                        
                </div>
              </div>
            </div>

      <Footer />
    </div>
  );
}

export default NewsArticle;

